import * as React from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import { Card, CardContent } from "@/components/ui/card";
import { ACTIONS, ENTITY_TYPES } from "./helpers";

interface AuditFiltersProps {
  entityType: string;
  action: string;
  offset: number;
  limit: number;
  total: number;
  onEntityTypeChange: (v: string) => void;
  onActionChange: (v: string) => void;
  onOffsetChange: (v: number) => void;
}

export function AuditFilters({
  entityType,
  action,
  offset,
  limit,
  total,
  onEntityTypeChange,
  onActionChange,
  onOffsetChange,
}: AuditFiltersProps): React.ReactElement {
  return (
    <Card className="mb-4">
      <CardContent className="grid gap-3 pt-6 md:grid-cols-3">
        <div className="space-y-1.5">
          <Label htmlFor="entityType">Tipo de entidade</Label>
          <Select
            id="entityType"
            value={entityType}
            onChange={(e) => onEntityTypeChange(e.target.value)}
          >
            {ENTITY_TYPES.map((t) => (
              <option key={t || "_all"} value={t}>
                {t || "Todas"}
              </option>
            ))}
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="action">Ação</Label>
          <Select id="action" value={action} onChange={(e) => onActionChange(e.target.value)}>
            {ACTIONS.map((a) => (
              <option key={a || "_all"} value={a}>
                {a || "Todas"}
              </option>
            ))}
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label>Página</Label>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => onOffsetChange(Math.max(0, offset - limit))}
              disabled={offset === 0}
            >
              Anterior
            </Button>
            <span className="text-muted-foreground text-xs">
              {offset + 1} – {Math.min(offset + limit, total)} de {total}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onOffsetChange(offset + limit)}
              disabled={offset + limit >= total}
            >
              Próxima
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
